import React, { useEffect } from "react";
import styles from "./FetchingRepayment.module.scss";

export default function FetchingRepayment() {
  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.wrapper}>
      <h3>Please hold on...</h3>
      <img src="/images/fetching-data.jpg" alt="" />
      <p>Fetching your repayment details</p>
    </div>
  );
}
